import React, { Component } from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

class App extends Component {
    render() {
        return (
            <div className="sid-body">
                <div className="sid-banner">
                    <img src="https://assets-resources.sheerid.com/icebreaker/img/icebreaker-logo-mtn-black.svg" alt="Icebreaker" className="sid-center"/>
                </div>
                        <div className="sid-medical-header">
                            <span>MEDICAL DISCOUNT</span>
                        </div>
                            <div className="sid-verification-form">
                                <VerificationForm programId={programId} />
                            </div>
            </div>
        );
    }
}

export default App;
